import { AsaSnackProps } from '@/components/notistack/AsaSnack';
import { MedsAutomationSnackProps } from '@/components/notistack/MedsAutomationSnack';

export * from './AsaSnack';
export * from './MedsAutomationSnack';

declare module 'notistack' {
  interface VariantOverrides {
    asa: AsaSnackProps;
    medsAutomation: MedsAutomationSnackProps;
  }
}
